import axios from "axios";
// import Swal from "sweetalert2"; // <-- REMOVED


// When frontend is served from the same server as the backend (e.g. /app/),
// use a relative path so all API calls go to the same origin.
// If deploying frontend separately, set this to the full backend URL.
const serverURL = "https://new.zaptodoor.com"; // empty = same origin (relative)

async function getData(url) {
  try {
    const config = {
      headers: {
        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.get(`${serverURL}/${url}`, config);
    return response.data;
  } catch (e) {
    console.error(e);
    return {
      ...(e.response?.data || {}),
      success: false,
      data: e.response?.data?.data || null,
      error: e.response?.data?.message || e.message || "Request failed",
      message: e.response?.data?.message || e.message || "Request failed",
    };
  }
}


async function postData(url, body) {
  try {
    const config = {
      headers: {
        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.post(`${serverURL}/${url}`, body, config);
    return response.data;
  } catch (e) {
    console.error(e);
    return {
      ...(e.response?.data || {}),
      success: false,
      data: e.response?.data?.data || null,
      error: e.response?.data?.message || e.message || "Request failed",
      message: e.response?.data?.message || e.message || "Request failed",
    };
  }
}

async function postFormData(url, formData) {
  try {
    const response = await axios.post(`${serverURL}/${url}`, formData, {
      headers: {
        Authorization: `${localStorage.getItem("Token")}`,
      },
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return {
      ...(e.response?.data || {}),
      success: false,
      data: e.response?.data?.data || null,
      error: e.response?.data?.message || e.message || "Request failed",
      message: e.response?.data?.message || e.message || "Request failed",
    };
  }
}

function getDate() {
  const cd = new Date();
  return `${cd.getFullYear()}/${cd.getMonth() + 1}/${cd.getDate()}`;
}

function getTime() {
  const cd = new Date();
  return `${cd.getHours()}:${cd.getMinutes()}:${cd.getSeconds()}`;
}
async function putData(url, body) {
  try {
    const config = {
      headers: {
        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.put(`${serverURL}/${url}`, body, config);
    return response.data;
  } catch (e) {
    console.error(e);
    return {
      ...(e.response?.data || {}),
      success: false,
      status: false,
      data: e.response?.data?.data || null,
      error: e.response?.data?.message || e.message || "Request failed",
      message: e.response?.data?.message || e.message || "Request failed",
    };
  }
}

async function deleteData(url) {
  try {
    const config = {
      headers: {
        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.delete(`${serverURL}/${url}`, config);
    return response.data;
  } catch (e) {
    console.error(e);
    return {
      ...(e.response?.data || {}),
      success: false,
      status: false,
      data: e.response?.data?.data || null,
      error: e.response?.data?.message || e.message || "Request failed",
      message: e.response?.data?.message || e.message || "Request failed",
    };
  }
}

export { getData, postData, postFormData, putData, deleteData, serverURL, getDate, getTime };

